// extracted by mini-css-extract-plugin
export var container = "z_h";
export var email = "z_b8";
export var emails = "z_b7";
export var location = "z_b9";
export var number = "z_b6";
export var numbers = "z_b5";